import React, { useRef, useEffect } from "react";

function useOutsideAlerter(ref, onOutside) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onOutside();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

export default function OutsideAlerter(props) {
    const {onOutside} = props;
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, onOutside);

    return <div ref={wrapperRef}>{props.children}</div>;
}